import { faChevronLeft } from '@fortawesome/pro-regular-svg-icons/faChevronLeft';
import { faChevronRight } from '@fortawesome/pro-regular-svg-icons/faChevronRight';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import styled from 'styled-components6';
import { mqDown } from '../../theme';

export const SCROLL_BUTTON_HEIGHT = 28;

const CommonButton = styled.div<{ disabled: boolean }>`
    background-color: ${(props) =>
        props.disabled
            ? 'var(--rwl-palette-gray-100)'
            : 'var(--rwl-palette-gray-200)'};
    width: ${SCROLL_BUTTON_HEIGHT}px;
    height: ${SCROLL_BUTTON_HEIGHT}px;
    display: flex;
    align-items: center;
    justify-content: center;

    &:hover {
        background-color: ${(props) =>
            props.disabled
                ? 'var(--rwl-palette-gray-100)'
                : 'var(--rwl-palette-gray-400)'};
        cursor: ${(props) => (props.disabled ? 'not-allowed' : 'pointer')};
    }

    color: black;
    cursor: pointer;
    z-index: 1;
`;

// Negative margins to offset padding of carousel container
const ScrollButtonsDivLeft = styled(CommonButton)`
    border-radius: 50%;
    ${mqDown('xs')} {
        margin-left: -10px;
    }
`;

const ScrollButtonsDivRight = styled(CommonButton)`
    border-radius: 50%;
    ${mqDown('xs')} {
        margin-right: -10px;
    }
`;

interface ScrollButtonsProps {
    direction: 'left' | 'right';
    onClick: (e: React.MouseEvent<HTMLDivElement>) => void;
    disableLeft?: boolean;
    disableRight?: boolean;
    style?: React.CSSProperties;
}

export const ScrollButton = ({
    direction,
    onClick,
    disableLeft,
    disableRight,
    style,
}: ScrollButtonsProps) =>
    direction === 'left' ? (
        <ScrollButtonsDivLeft
            role={'button'}
            className={'scrollButton scrollButtonLeft'}
            aria-label={'Scroll left'}
            onClick={onClick}
            disabled={!!disableLeft}
            style={style}
        >
            <FontAwesomeIcon icon={faChevronLeft} />
        </ScrollButtonsDivLeft>
    ) : (
        <ScrollButtonsDivRight
            role={'button'}
            className={'scrollButton scrollButtonRight'}
            aria-label={'Scroll right'}
            onClick={onClick}
            disabled={!!disableRight}
            style={style}
        >
            <FontAwesomeIcon icon={faChevronRight} />
        </ScrollButtonsDivRight>
    );
